export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";